import { Col, Form, FormInstance, Input, Row } from "antd";
import React from "react";
import { VPDLabel } from "~/context/taxonomy-context";
import {
  ClientAutoComplete,
  ClientFilterData,
  ClientValue,
  NewClientValue,
} from "../client-auto-complete";
import { ParentPhases } from "./ParentPhases";

type Props = {
  form: FormInstance;
  selectedClient: ClientValue | undefined | null;
  clientFilterData: ClientFilterData;
  onClientSave: (newClient: NewClientValue) => void;
};

export const CreateMultiDisc: React.FC<Props> = ({
  form,
  onClientSave,
  selectedClient,
  clientFilterData,
}) => {
  const PA_LABEL = VPDLabel("PracticeArea");

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <Form form={form} layout="vertical">
        <Row>
          <Col span={24}>
            <Form.Item
              label="Client"
              name="client"
              trigger="onChangeClient"
              required
              rules={[
                {
                  required: true,
                  message: "Please select a Client",
                },
              ]}
              shouldUpdate
            >
              <ClientAutoComplete
                defaultValue={selectedClient}
                value={selectedClient}
                disabled={false}
                onChangeClient={(v) => {
                  form.setFieldsValue({
                    externalMatterId: undefined,
                    client: v,
                  });
                }}
                onClientSave={onClientSave || (() => {})}
                onClear={() => {
                  form.setFieldsValue({
                    externalMatterId: undefined,
                    client: undefined,
                  });
                }}
                clientFilterData={clientFilterData}
                bordered
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item
              required
              label={`Multi ${PA_LABEL} Proposal Title`}
              name="multiDiscTitle"
              rules={[
                {
                  required: true,
                  message: `Multi ${PA_LABEL} Proposal Title`,
                },
              ]}
            >
              <Input placeholder="Multi Practice Area Proposal Title" />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item required label="Proposal Phases" name="parentPhases">
              <ParentPhases form={form} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};
